var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H24V23.04H0V0ZM2 2V21.04H22V2H2Z",
    fill: "#7F5FEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9103 9.64941C13.6024 9.64941 13.2976 9.71017 13.0132 9.8282C12.7288 9.94624 12.4706 10.1192 12.2532 10.3373C12.0358 10.5553 11.8636 10.8141 11.7464 11.0988C11.6292 11.3835 11.5694 11.6885 11.5703 11.9964L11.5703 11.9994H11.5703V18.2194H9.57031V12.0008M13.9103 7.64941C15.064 7.64942 16.1704 8.10772 16.9862 8.9235C17.802 9.73928 18.2603 10.8457 18.2603 11.9994V18.2194H16.2603V11.9994C16.2603 11.3762 16.0127 10.7784 15.572 10.3377C15.1313 9.897 14.5336 9.64941 13.9103 9.64941H13.9103",
    fill: "#7F5FEE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.73828 18.2195V7.68945H7.73828V18.2195H5.73828Z",
    fill: "#7F5FEE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.74125 6.73934C7.27144 6.73934 7.70125 6.30953 7.70125 5.77934C7.70125 5.24914 7.27144 4.81934 6.74125 4.81934C6.21106 4.81934 5.78125 5.24914 5.78125 5.77934C5.78125 6.30953 6.21106 6.73934 6.74125 6.73934Z",
    fill: "#7F5FEE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.57031 12.4795V7.68945H11.5703V12.4795H9.57031Z",
    fill: "#7F5FEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/linkedIn.e1b9e9ac724076842dbc7fb00f0a0e34.svg";
export { ForwardRef as ReactComponent };